import { Link as LinkIco, Layers as LayersIco } from 'lucide-react'

/**
 * Modal-mode cell for `type: object-ref` fields. Renders a preview button
 * that opens the ObjectRefEditor as a sub-modal.
 *
 * Surfaces :
 *  - empty                 → "Choisir…"
 *  - single + label        → that label
 *  - single + no label     → "#id (type)"
 *  - multiple (N items)    → "N items"
 */
const baseButton =
  'flex items-center gap-2 px-3 py-2 border border-gray-200 rounded-lg hover:border-teal-400 hover:bg-teal-50/30 text-sm text-gray-700 transition-colors w-full text-left'

export const ObjectRefCell = ({ value, onClick }) => {
  const summary = describe(value)
  const isList = Array.isArray(value) && value.length > 0
  return (
    <button type="button" onClick={onClick} className={baseButton}>
      <span className="w-8 h-8 rounded flex-shrink-0 bg-gray-100 flex items-center justify-center">
        {isList ? (
          <LayersIco size={14} className="text-gray-400" />
        ) : (
          <LinkIco size={14} className="text-gray-400" />
        )}
      </span>
      <span className="truncate text-xs text-gray-600">{summary}</span>
    </button>
  )
}

function describe(value) {
  if (value == null || value === '') return 'Choisir…'
  if (Array.isArray(value)) {
    if (value.length === 0) return 'Choisir…'
    if (value.length === 1) return value[0]?.label || `#${value[0]?.id}`
    return `${value.length} sélections`
  }
  if (typeof value === 'object') {
    if (value.label) return value.label
    if (value.id != null) return `#${value.id}${value.type ? ` (${value.type})` : ''}`
  }
  return '— vide'
}
